const cleanPhoneNumber = s =>
  s
    .replace(/\D/g, '')
    .replace(/^1/g, '')
    .slice(-10);

export default cleanPhoneNumber;
